import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

function RenameFolderDialog({
  open,
  onClose,
  onSubmit,
  existingFolderNames,
  initialName,
}) {
  const [newName, setNewName] = useState(initialName || "");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewName(initialName || "");
    setError("");
  }, [initialName, open]);

  const handleChange = (e) => {
    setNewName(e.target.value);
    if (error) setError("");
  };

  const handleSubmit = async () => {
    if (!newName.trim()) {
      setError("Folder name cannot be empty.");
      return;
    }
    if (
      existingFolderNames.includes(newName.trim()) &&
      newName.trim() !== initialName
    ) {
      setError("A folder with this name already exists.");
      return;
    }
    setLoading(true);
    try {
      console.log(
        "[DEBUG][USER][TITLE] RenameFolderDialog.jsx -> handleSubmit"
      );
      await onSubmit(newName.trim());
      console.log("[DEBUG][USER] handleSubmit -> SUCCESS");
      setLoading(false);
    } catch (err) {
      setError(err.message || "Failed to rename folder. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Rename Folder</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="New Folder Name"
          type="text"
          fullWidth
          value={newName}
          onChange={handleChange}
          error={Boolean(error)}
          helperText={error}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={loading}
          variant="contained"
          color="primary"
        >
          {loading ? <CircularProgress size={24} /> : "Rename"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RenameFolderDialog;
